import React, { useState, useEffect } from "react"
import { useAppCtx, appStore } from "lib/state"
import { appTools, cn } from "lib/utils"
import ImageManager from "lib/modules/ImageManager/ImageManager"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider";
import SectionHeaderRender from "lib/units/element/SectionHeader/SectionHeaderRender"
import { useRenderStyling, renderStyle } from "lib/hooks/useRenderStyling"

export default function SupportingImagesRender() {

  const { store, AppStore } = appStore() 
  const { update } = AppStore

  const { mode, subdomain, getElementConfig, getApiFeedData }:any = useTemplatePreviewCtx() 
  const config = getElementConfig("supporting_images")

  const [ finalConfig, setFinalConfig ] = useState<any>({}) 
  const [ images, setImages ] = useState<any[]>([])
  const [ hiddenImageIds, setHiddenImageIds ] = useState<any[]>([])

  const hideImage = (Id:any) => {
    setHiddenImageIds([...hiddenImageIds, Id])
  }

  useEffect(() => {
    const imagesToLoad = getApiFeedData("rp.Documents") 
    setImages(imagesToLoad)
  },[])

  const prepFinalConfig = () => {
    const final = {
      ready: true,
      settings: {
        title: config.rendering?.title || "Supporting Images",
        maxToShow: config.rendering?.maxToShow || 999,
        filter: config.rendering?.filter || null,
        sortBy: config.rendering?.sortBy || null,
        imageLayout: config.rendering?.imageLayout || "vertical",
        displayIfNoImages: config.rendering?.displayIfNoImages || false,
        showImageTitles: config.rendering?.showImageTitles || true,
        showImageDescriptions: config.rendering?.showImageDescriptions || true,
        metaDataFormat: config.rendering?.metaDataFormat || "horizontal"
      }
    }
    setFinalConfig(final)
  }

  const getMeasurements = () => {
    const container = document.getElementById("mm-supporting-images")
    if( container ){
      const containerWidth = container.clientWidth
      const containerHeight = container.clientHeight
      update("preview.measurements.supportingImagesContainer", containerHeight )
    }
  }

  const outerStyling = useRenderStyling("mm-section w-full flex flex-col", "styleObj")
  const innerStyling = useRenderStyling("w-full flex flex-col justify-start items-start pl-6 pr-6 mt-3 mb-6", "styleObj")
  const outerImage = useRenderStyling("w-full flex flex-col pl-2 mb-8 w-21/24", "styleObj")
  const outerCaption = useRenderStyling("border-b border-b-solid border-b-neutral-400 pb-1 mb-2", "styleObj")
  const captionTitle = useRenderStyling("font-semibold text-lg", "styleObj")


  // useEffect(() => {
  //   if( finalConfig.ready ){
  //     getMeasurements()
  //   }
  // },[finalConfig])

  useEffect(() => {
    prepFinalConfig()
  },[config])

  if( !finalConfig.ready ) return <></>
  return (
    <div id="mm-supporting-images" {...outerStyling}>

      <SectionHeaderRender title="Supporting Images" />

      <div {...innerStyling}>

        { store.preview.editing?.action === "image-manager" ? (
          <ImageManager />
        ) : 
        
        images?.map( (item:any, idx:number) => (
          <div 
            key={item.Id} 
            className={cn("supporting-image-container", idx === 0 && "first")}
            style={{ display: "block", pageBreakInside: "avoid", breakInside: "avoid" }}
          >
            <div {...outerImage}>
              <div {...outerCaption}> 
                <h3 {...captionTitle}>{item.Title}</h3>
                {/* <p style={{ fontSize: ".2rem" }}>{item.Src}</p> */}
                <span>{item.Notes}</span>
              </div>
              <img src={`https://${subdomain}.midmetrics.io/${item.Src}`} alt={`Image ${idx}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}